import prettyBytes from 'pretty-bytes';

export * from './formatters/timestamp.js'
export * from './formatters/string.js'
export * from './formatters/duration.js'

/**
 * @param {number} value
 * @param {number} [maxFractionDigits]
 * @returns {string}
 */
export function formatSize(value, maxFractionDigits = 2) {
  return prettyBytes(value, {
    maximumFractionDigits: maxFractionDigits,
  });
}

/**
 * @param {number} value
 * @param {number} precision
 * @returns {string}
 */
export function toKilo(value, precision) {
  if (typeof value !== 'number' || isNaN(value)) {
    throw new TypeError('value parameter must be a number.');
  }

  if (value >= 1000) {
    return (value / 1000).toFixed(precision) + "K";
  }

  return String(value);
}
